import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/AmazonCTA.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/comparison/ProductComparisonTable.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/CTAVisibilityTracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/MultiVendorCTA.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/ProductViewTrackerWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/review/BottomLineSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/review/EmailCaptureSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/review/RelatedProductsGrid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReviewHeroCTA"] */ "/vercel/path0/components/review/ReviewHeroCTA.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StickyMobileCTAWrapper"] */ "/vercel/path0/components/StickyMobileCTA.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
